import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, CalendarIcon, ChatBubbleLeftIcon, SparklesIcon } from '@heroicons/react/24/outline';
import { activeNavIndex } from '../nav-active';

interface Props { homeChildId: string | null; unreadMessages: number; unreadObservations: number }

/** Phone-only bottom tabs for the parent frame; the desktop sidebar carries the same four. Layout renders it only once a child is decided and never on the chooser (/parent/choose), even when a remembered child sets homeChildId there. */
const ParentTabBar: React.FC<Props> = ({ homeChildId, unreadMessages, unreadObservations }) => {
  const { pathname } = useLocation();
  if (!homeChildId) return null;
  const base = `/parent/${homeChildId}`;
  const tabs = [
    // Exact: the child's sub-pages (details, forms…) are not Home.
    { key: 'home', label: 'Home', href: base, exact: true, icon: HomeIcon, badge: 0 },
    { key: 'schedule', label: 'Schedule', href: `${base}/calendar`, icon: CalendarIcon, badge: 0 },
    { key: 'inbox', label: 'Inbox', href: '/parent/family/inbox', icon: ChatBubbleLeftIcon, badge: unreadMessages },
    { key: 'updates', label: 'Updates', href: `${base}/updates`, icon: SparklesIcon, badge: unreadObservations },
  ];
  const active = activeNavIndex(pathname, tabs);
  return (
    <nav data-testid="parent-tab-bar" aria-label="Parent navigation" className="lg:hidden fixed inset-x-0 bottom-0 z-20 bg-white border-t border-gray-200 pb-[env(safe-area-inset-bottom)]">
      <ul className="grid grid-cols-4">
        {tabs.map((t, i) => (
          <li key={t.key}>
            <Link to={t.href} data-testid={`tab-${t.key}`} aria-current={i === active ? 'page' : undefined} className={`relative flex flex-col items-center gap-0.5 py-2 text-[11px] ${i === active ? 'text-primary-600 font-semibold' : 'text-gray-500'}`}>
              <t.icon className="h-6 w-6" />
              {t.label}
              {t.badge > 0 && <span data-testid={`tab-${t.key}-badge`} className="absolute top-1 right-[calc(50%-18px)] min-w-[16px] h-4 rounded-full bg-red-500 text-white text-[10px] font-semibold px-1 flex items-center justify-center">{t.badge}</span>}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};
export default ParentTabBar;
